module.exports = __webpack_public_path__ + "img/2_user.95a63344.svg";